module.exports = __webpack_public_path__ + "static/media/friday-che-routes-mobile@2x.5432b49c.png";